import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';

import { SafeAnyType } from 'src/utils/safeAny';

/**
 *  remove falsey values from object
 *  it doesn't check nested values
 */
export const omitFalseyObjectValues = <T extends Record<string, SafeAnyType>>(obj: T): T => pickBy(obj, identity) as T;

/**
 *  omit both null and undefined values from object
 *  it doesn't check nested values
 */
export const omitNilObjectValues = <T extends Record<string, SafeAnyType>>(obj: T): T => omitBy(obj, isNil) as T;

/**
 * returns true if all properties are in the object
 */
export const objectHasProperties = <T extends Record<string, SafeAnyType>>(obj: T, properties: string[]): boolean => {
  for (let i = 0; i < properties.length; i += 1) {
    if (!Object.prototype.hasOwnProperty.call(obj, properties[i])) {
      return false;
    }
  }
  return true;
};

export const createArrayXLength = (length: number): number[] => [...new Array(length).keys()];
